import { render, staticRenderFns } from "./Next.vue?vue&type=template&id=2449b129&scoped=true&"
import script from "./Next.vue?vue&type=script&lang=ts&"
export * from "./Next.vue?vue&type=script&lang=ts&"
import style0 from "./Next.vue?vue&type=style&index=0&id=2449b129&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2449b129",
  null
  
)

export default component.exports